














































import { Component, Vue } from "vue-property-decorator"

@Component({ name: "Sidebar" })
export default class Sidebar extends Vue {
  public menus = {
    Onyx: [
      // each category can have any number of subCategories (Categories are only titles, not clickable links/tabs)
      {
        // each category can have any number of expandable tabs
        action: "",
        icon: "mdi-view-dashboard",
        title: "Galaxy",
        active: true,
        label: "Old",
        items: [
          // each expandable tab can have any number of links/items underneath it
          { title: "PM Summary Report", path: "/", exact: true, label: "Old" },
          {
            title: "Margin Detail Report",
            path: "/home/MarginDetailReport",
            exact: true,
            label: "Old",
          },
          {
            title: "Accounting RTB Summary Report",
            path: "/home/AccountingRTBSummaryReport",
            exact: true,
            label: "Old",
          },
          {
            title: "Eclipse Jobs Report",
            path: "/home/EclipseJobsReport",
            exact: true,
            label: "Old",
          },
        ],
      },
    ],
  }
}
